import * as React from 'react';
import { connect } from 'react-redux';
import store from '../store/store';
import types from '../store/types';
import { InitialisationHelper, ConfigHelper, Authenticate } from '../helpers';
import { Spinner, SpinnerType } from 'office-ui-fabric-react';
import AdminToolContainer from '../containers/admintool-container';
import ModalContainer from '../containers/modal';

class AdminContainer extends React.Component<any, any> {

    componentDidMount() {
        load();
    }
    
    public render() {
        
        let { loading } = this.props;
        
        return (
            <div>
                <ModalContainer />
                {loading ? <Spinner className="designer-loader" type={SpinnerType.large} label="Loading..." /> : 
                    <AdminToolContainer back={() => {window.location.href = window.location.origin;}} />}
            </div>
        );
    }

};

let load = () => {

    store.dispatch({ type: types.SET_LOADING, loading: true });

    ConfigHelper
        .loadAuthenticationSettings()
        .then(settings => {
            InitialisationHelper.setConfigSettings(settings);
            store.dispatch({
                type: types.SET_SUPPRESS_HASH_CHANGE,
                suppressHashChange: true
            });
            return Authenticate(settings);
        })
        .then(token => {
            store.dispatch({ type: types.SET_LOADING, loading: true });
            return ConfigHelper.loadUrls();
        })
        .then(urls => {
            store.dispatch({ type: types.SET_LOADING, loading: false });
        });
};

let mapStateToProps = (store) => {
    return {
        loading: store.cacheState.loading
    };
};

export default connect<any, any, any>(mapStateToProps)(AdminContainer);


// WEBPACK FOOTER //
// ./source/ts/containers/admin.tsx